import React, { useEffect, useState, useRef } from "react";
import classes from "../style/Style.module.css";
import "../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  Gender_Dob_Verification,
  ROUTE_CHECKBOXES,
  ROUTE_EMAIL,
  ROUTE_ACCOUNT_TYPE,
  Address_Verification,ROUTE_NOMINEE_DETAILS,
  ROUTE_OCCUPATION,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_NOMINEE_SENDOTP,ROUTE_NRI_Address,
  ROUTE_DXTER_SCANNING,
} from "../Routes";
import { useNavigate } from "react-router-dom";
import BirthCountryOptions from "../Components/CountryNames";
import Lock from "../Images/Lock.svg";
import BirthCountryCode from "../Components/CountrynameCode";
import { useSelector } from "react-redux";
import { selectPhoneNumber } from "../Store/MobileSlice";
import { selectPanNumber } from "../Store/panNumberSlice";
import axios from "../libs/axiosConfig";
import Toast from "../Components/ToastMsg/Toast";
import { ToastContainer } from "react-toastify";
import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import Modal from "react-modal";
import LogoutModal from "../Components/LogoutModal";

const PlaceofBirth = () => {
  const Navigate = useNavigate();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const [formErrors, setFormErrors] = useState({});
  const [BirthPlace, setBirthPlace] = useState("");
  const [BirthCountry, setBirthCountry] = useState("");
  const [occupation, setoccupation] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionss, setSuggestionss] = useState([]);
  const [showSuggestionss, setShowSuggestionss] = useState(false);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const refreshToken = useSelector(selectRefreshToken);
  const [showModal, setShowModal] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  const dropdownRef = useRef(null);
// console.log(BirthCountry)
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowSuggestions(false);
    }
  };

  const handleBirthPlaceChange = (e) => {
    const input = e.target.value;
    const alphabetsOnly = /^[A-Za-z\s,.]+$/;

    if (alphabetsOnly.test(input) || input === "") {
      setBirthPlace(input);
    }
  };

  const handleBackspace = (e) => {
    const input = e.target.value;
    setBirthPlace(input);
  };

  const handleBirthCountryChange = (e) => {
    const input = e.target.value;
    const alphabetsOnly = /^[A-Za-z\s]+$/;

    if (alphabetsOnly.test(input) || input === "") {
      setBirthCountry(input);

      const filteredSuggestions = BirthCountryCode.filter(
        (item) =>
          item.name.toLowerCase().startsWith(input.toLowerCase()) &&
          item.name.toLowerCase() !== input.toLowerCase()
      ).map((item) => item.name);

      setSuggestions(filteredSuggestions);
      setShowSuggestions(true);
    }
  };

  const handleBirthPlaceClear = () => {
    setBirthPlace("");
  };

  const handleBirthCountryShow = () => {
    if (showSuggestions) {
      setShowSuggestions(false);
    } else {
      const filteredSuggestions = BirthCountryCode.filter(
        (item) =>
          item.name.toLowerCase().startsWith(BirthCountry.toLowerCase()) &&
          item.name.toLowerCase() !== BirthCountry.toLowerCase()
      ).map((item) => item.name);

      setSuggestions(filteredSuggestions);
      setShowSuggestions(true);
    }
  };

  const handleSuggestionClick = (selectedCountryName) => {
    setBirthCountry(selectedCountryName);

    const selectedCountry = BirthCountryCode.find(
      (country) => country.name === selectedCountryName
    );
    if (selectedCountry) {
      setSelectedCountryCode(selectedCountry.code);
    }
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const handleoccupationSuggestionClick = (occupation) => {
    setoccupation(occupation);
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const HandleBack = () => {
    setShowModal(true);
  };
  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const HandleSubmit = async () => {
    try {
      setApiCallsInProgress(apiCallsInProgress + 1);
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      const FormatedBirthPlace = BirthPlace.replace(/[,\.]/g, " ");
console.log(selectedCountryCode);
      // Make a POST request to the first API endpoint
      const firstapi =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
      const requestBody = {
        CustomerKycDetails: {
          request_type: "post",
          mobileNumber: phoneNumber,
          pan: panNumber,
          placeOfBirth: FormatedBirthPlace,
          nseCountryCodeOfBirth: selectedCountryCode,
          nseCountryOfBirth: BirthCountry,
        },
      };

      const response = await axios.post(firstapi, requestBody, { headers });
      console.log("First API Response:", response.data);

     
      

      if (response.status === 200) {
        const thirdapi =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const thirdRequestBody = {
          CustomerKycDetails: {
            request_type: "get",
            mobileNumber: phoneNumber,
            pan: panNumber,
          },
        };
        // setApiCallsInProgress(apiCallsInProgress - 1);

        const thirdResponse = await axios.post(thirdapi, thirdRequestBody, {
          headers,
        });

        

        if (
          thirdResponse.data.statusCode === 200 &&
          thirdResponse.data.status === true 
          
        ) {
          setApiCallsInProgress(apiCallsInProgress - 1);

          if (
            thirdResponse.data.body.emailId === "" 
            
          ) {
            Navigate(ROUTE_EMAIL);
          } else if (
            thirdResponse.data.body.bankAccountNumber === "" ||
            
            thirdResponse.data.body.bankIfscCode === "" ||
           
            thirdResponse.data.body.bankAccountType === "" ||
           
            thirdResponse.data.body.bankName === "" ||
           
            thirdResponse.data.body.bankBranchName === "" ||
          
            thirdResponse.data.body.bankBranchAddress === "" ||
           
            thirdResponse.data.body.bankCodeNSE === "" ||
           
            thirdResponse.data.body.bankCodeBillDesk === "" ||
            
            thirdResponse.data.body.bankAccountHolderName === "" 
          
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            (thirdResponse.data.body.bankAccountNumber !== "" ||
              
              thirdResponse.data.body.bankIfscCode !== "" ||
              
              thirdResponse.data.body.bankAccountType !== "" ||
             
              thirdResponse.data.body.bankName !== "" ||
              
              thirdResponse.data.body.bankBranchName !== "" ||
             
              thirdResponse.data.body.bankBranchAddress !== "" ||
              
              thirdResponse.data.body.bankCodeNSE !== "" ||
             
              thirdResponse.data.body.bankCodeBillDesk !== "" ||
             
              thirdResponse.data.body.bankAccountHolderName !== "" 
              ) &&
            (thirdResponse.data.body.bankVerified.account_exists !== "True" ||
              thirdResponse.data.body.bankVerified.message !== "success" 
              )
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            thirdResponse.data.body.panDetails.gender === "" ||
            
            thirdResponse.data.body.panDetails.title === "" ||
           
            thirdResponse.data.body.panDetails.dob === "" 
            
          ) {
            Navigate(Gender_Dob_Verification);
          } else if (
            thirdResponse.data.body.panDetails.addr1 === "" ||
            
            thirdResponse.data.body.panDetails.addr2 === "" ||
          
            thirdResponse.data.body.panDetails.city === "" ||
            
            thirdResponse.data.body.panDetails.state === "" ||
          
            thirdResponse.data.body.panDetails.pincode === "" ||
          
            thirdResponse.data.body.panDetails.country === "" ||
            
            thirdResponse.data.body.panDetails.fullAddress === "" 
           
          ) {
            Navigate(Address_Verification);
          } else if (
            thirdResponse.data.body.nseIncomeCode === "" ||
         
            thirdResponse.data.body.nseIncomeCodeDescription === "" ||
           
            thirdResponse.data.body.nseOccupationCode === "" ||
           
            thirdResponse.data.body.nseOccupationCodeDescription === "" 
          ) {
            Navigate(ROUTE_OCCUPATION);
          } else if (
            thirdResponse.data.body.politicallyExposedPerson === "" ||
          
            thirdResponse.data.body.relatedToPoliticallyExposedPerson === "" 
            
          ) {
            Navigate(ROUTE_CHECKBOXES);
          } else if (
            ((thirdResponse.data.body.nomineeDob !== "" 
             ) &&
              thirdResponse.data.body.nomineeName === "") 
           
          ) {
            
            Navigate(ROUTE_NOMINEE_DETAILS);
          } else if (
            ((thirdResponse.data.body.nomineeName !== "" 
            ) &&
              thirdResponse.data.body.nomineeDob === "")
          ) {
            
            Navigate(ROUTE_NOMINEE_DETAILS);
          } else if (
            (thirdResponse.data.body.nomineeName !== "" &&
            thirdResponse.data.body.nomineeType !== "" &&
            thirdResponse.data.body.nomineeRelationShip !== "" &&
            thirdResponse.data.body.nomineeDob !== "" 
              ) &&
            (thirdResponse.data.body.nomineeVerified === "N" 
             )
          ) {
            console.log("first");
            Navigate(ROUTE_NOMINEE_SENDOTP);
          }

          else {
          const requestBody = {
            dexterrCustomerBasicQuestions: {
              mobile_no: phoneNumber,
              request_type: "get",
              country_code: "+91",
            }
          };
          const headers = {
            Authorization: `Bearer ${storedToken}`,
            // RefreshToken: refreshToken
          };
    
          const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
            headers: headers
          });
          if (secondApiResponse.data.data.resident !== "Resident Indian") {
            Navigate(ROUTE_NRI_Address)
          }
          
          else {
            Navigate(ROUTE_DXTER_SCANNING);
          }
        }
        } else {
          Toast.error(
            thirdResponse.data.message + " " + thirdResponse.data.errorMessage
          );
          setApiCallsInProgress(apiCallsInProgress - 1);
        }
      } else {
        Toast.error(
          response.data.message + " " + response.data.errorMessage
        );
        setApiCallsInProgress(apiCallsInProgress - 1);
      }
      setApiCallsInProgress(apiCallsInProgress - 1);
    } catch (error) {
      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
          "Error"
      );
    }
  };

  return (
    <div className="Placeofbirth_Main_Container">
      <div className="Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
      </div>
      <div className="Placeofbirth_Div_Container">
        <p className="Input_Heading_text">Place of Birth</p>

        <div className="Regulatory_Requirement_Container">
          <img alt="Lock-img" src={Lock} />
          <span className="Regulatory_Requirement_Text">
            Regulatory requirement
          </span>
        </div>

        {/* Nominee Date of Birth Input */}
        <div className="Placeofbirth_Filed_Box">
          <span className="Enter_mobile_text">Place of birth</span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${
                formErrors.ifscCode ? classes.Error : ""
              }`}
              value={BirthPlace}
              onChange={handleBirthPlaceChange}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  handleBackspace(e);
                }
              }}
            />
            <button
              className={classes.Cross_button}
              onClick={handleBirthPlaceClear}
            />
          </div>
        </div>

        {/* Nominee Relation Input with Suggestions */}
        <div className="secondplaceofbirth_Filed_Box" ref={dropdownRef}>
          <span className="Enter_mobile_text2">Country of Birth</span>
          <div className="Input_Inner_Container2">
            <input
              className={`${classes.Input_Filed} ${
                formErrors.ifscCode ? classes.Error : ""
              }`}
              value={BirthCountry}
              onChange={handleBirthCountryChange}
              onBlur={() => setShowSuggestions(true)}
            />

            <button
              className={classes.DropDown_button}
              onClick={handleBirthCountryShow}
            />
          </div>
          {showSuggestions && (
            <div className={classes.Suggestions_Container}>
              {suggestions.map((suggestion, index) => (
                <div
                  key={index}
                  className={classes.Suggest_Suggestion}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion}
                </div>
              ))}
            </div>
          )}
        </div>

        <button className="Submit_button" onClick={HandleSubmit}>
          {" "}
          Submit{" "}
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      <ToastContainer />
    </div>
  );
};

export default PlaceofBirth;
